import React from 'react';
import { Box } from '@mui/material';

import { ListImage, } from '../../style/image'
import NoImg from '../../_img/img_no_image.png'

export default function ContentsImage(props) {

    return (
        <>
            <Box sx={{
                width: props.width,
                maxWidth: props.maxWidth,
            }}>
                <ListImage
                    src={props.imgSrc}
                    onError={(e) => {
                        const img = e.target;

                        if (!img.dataset.retry) {
                            img.dataset.retry = "1";
                            img.src = props.imgSrc + "?retry=" + Date.now();
                            return;
                        }

                        img.src = NoImg;
                    }}
                    onClick={() => props.handleClick(props.row)} />
            </Box>
        </>
    )
}
